/**
 * Function that toggles the header menu.
 */
export default function header () {
  const hamburgerSelector = '[data-type="atom/buttons/hamburger"]'
  const closeSelector = '[data-type="atom/buttons/close"]'
  const headerSelector = '[data-type="organism/header/header"]'
  const hamburger = document.querySelector( hamburgerSelector )
  const closebtn = document.querySelector( closeSelector )

  // Nav Menu: external link class
  const menuLinks = document.querySelectorAll( '[data-type="organism/header/header"] ul > li' )
  menuLinks.forEach( addExternal )

  // navbar on scroll
  window.addEventListener( 'scroll', scrollFunction )

  if ( !hamburger || !close ) {
    return
  }

  hamburger.addEventListener( 'click', open )
  closebtn.addEventListener( 'click', rollup )

  /**
   * Perform the open.
   */
  function rollup () {
    const header = document.querySelector( headerSelector )
    header.classList.add( 'close-navmenu' )
    header.classList.remove( 'open-navmenu' )
  }

  /**
   * Perform the open.
   */
  function open () {
    const header = document.querySelector( headerSelector )
    header.classList.add( 'open-navmenu' )
    header.classList.remove( 'close-navmenu' )
  }

  /**
   * Add external class to nav menu links.
   * 
   * @param {Object} linkParent Elenent holding an anchor element to add icon to.
   */
  function addExternal ( linkParent ) {
    const externaLink = !linkParent.querySelector( 'a' ).href.startsWith( window.location.origin )
    if ( externaLink ) {
      linkParent.classList.add( 'external-link' )
    }
    
  }

  /**
   * Add class no nav on scroll.
   * 
   * @param {Object} linkParent Elenent holding an anchor element to add icon to.
   */
  function scrollFunction() {
    const header = document.querySelector( headerSelector )

    if ( document.body.scrollTop > 80 || document.documentElement.scrollTop > 80 ) {
      header.classList.add( 'scrolled' )
    } else {
      header.classList.remove( 'scrolled' )
    }
  }
}
